<template src="./Index.html"></template>

<script>
import AddView from "./actions/Add";
import EditView from "./actions/Edit";
import DetailsView from "./details/Details";

export default {
    components: {
        AddView,
        EditView,
        DetailsView,
    },
    created() {
        this.getAll();
    },
    computed: {


        users() {
            return this.$store.state.users.users;
        },
        pageCount() {
            return Math.ceil(
                this.$store.state.users.totalItems / this.filters.pageSize
            );
        },
    },
    data() {
        return {
            permissions:this.$settingPermissions.userPermissions,

            systemTypes: [
                { value: 0, label: 'كليهما' },
                { value: 1, label: 'واجهة الادارة' },
                { value: 2, label: 'واجهة الموظفين' },

            ],
            items: [
                {
                    text: "الاعدادات ",
                },
                {
                    text: "إدارة المستخدمين",
                },
            ],
            totalItems: 0,
            dialog: false,
            dialogType: null,
            dialogMessage: "",
            itemId: 0,
            view: 0,
            filters: {
                page: 1,
                pageSize: 10,
                loginName: null,
                userTypeId: null,
            },
            headers: [

                {
                    text: "اسم المستخدم",
                    value: "loginName",
                    sortable: false,
                    align: "start",
                },
                { text: "الوصف    ", value: "jobDescription", sortable: false },
                {
                    text: "اسم الموظف",
                    value: "fullName",
                    sortable: false,
                    align: "start",
                },

                { text: "مسجل بواسطة", value: "createdBy", sortable: false },
                { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
                { text: "الحالة", value: "status", sortable: false },
                {
                    text: "الإجراءات",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
        };
    },
    methods: {
        getAll(page) {
            this.filters.page = page || 1;
            this.$store.dispatch("users/getAll", this.filters);
        },
        addItem() {
            this.view = 1;
            this.items.push({ text: "إضافة المستخدم" });

        },
        editItem(item) {
            this.itemId = item.userId;
            this.view = 2;
            this.items.push({ text: "تعديل المستخدم" });

        },
        showDetails(item) {
            this.itemId = item.userId;
            this.view = 3;
            this.items.push({ text: "عرض التفاصيل" });

        },
        showDialog(item, type) {
            switch (type) {
                case "delete":
                    this.dialogMessage = "هل انت متأكد من رغبتك حذف المستخدم";
                    break;
                case "lock":
                    this.dialogMessage = "هل انت متأكد من رغبتك تجميد المستخدم";
                    break;
                case "unlock":
                    this.dialogMessage = "هل انت متأكد من رغبتك تفعيل المستخدم";
                    break;
                case "resetPassword":
                    this.dialogMessage = "هل انت متأكد من رغبتك اعادة تعيين كلمة المرور ";
                    break;
            }
            this.dialogType = type;
            this.itemId = item.userId;
            this.dialog = true;
        },

        confirmDialog() {
            switch (this.dialogType) {
                case "resetPassword": {
                    this.$store.dispatch(`users/${this.dialogType}`, this.itemId);
                    break;
                }
                default: {
                    this.$store.dispatch(`users/${this.dialogType}`, this.itemId);
                }
            }
            this.cancelDialog();
        },

        cancelDialog() {
            this.dialog = false;
            this.itemId = 0;
            this.dialogMessage = "";
            this.dialogType = null;
        },
        back() {
            this.view = 0;
            this.items = [
                {
                    text: "الاعدادات ",
                },
                {
                    text: "إدارة المستخدمين",
                },
            ];
        },
        reload() {
            this.filters.loginName = null;
            this.filters.userTypeId = null; this.getAll(1);
            this.back();
        },
    },
};
</script>
